import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.5.833c-1.127-.017-1.127 1.683 0 1.667H15v2.11L10.328 8.5 8.705 4.166h.462c1.126.017 1.126-1.683 0-1.666H5.833c-1.126-.017-1.126 1.683 0 1.666H6.92l1.485 3.959A5.75 5.75 0 0 0 5.833 7.5C2.622 7.5 0 10.12 0 13.333s2.622 5.833 5.833 5.833c3.212 0 5.834-2.621 5.834-5.833a5.754 5.754 0 0 0-.884-3.04l4.702-3.917.772 1.934c-1.74 1.013-2.924 2.875-2.924 5.023 0 3.212 2.622 5.833 5.834 5.833 3.211 0 5.833-2.621 5.833-5.833S22.378 7.5 19.167 7.5c-.472 0-.924.071-1.364.178l-1.136-2.842v-3.17a.833.833 0 0 0-.834-.833H12.5ZM5.833 9.166a4.133 4.133 0 0 1 2.592.922L5.3 12.692c-.852.711.213 1.991 1.067 1.283l3.125-2.605c.313.587.508 1.25.508 1.963A4.153 4.153 0 0 1 5.833 17.5a4.153 4.153 0 0 1-4.166-4.167 4.153 4.153 0 0 1 4.166-4.167Zm13.334 0a4.153 4.153 0 0 1 4.166 4.167 4.153 4.153 0 0 1-4.166 4.167A4.153 4.153 0 0 1 15 13.333a4.15 4.15 0 0 1 1.875-3.48l1.517 3.79c.41 1.038 1.966.417 1.55-.62L18.428 9.24a4.46 4.46 0 0 1 .739-.074Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }